import Pusher from "pusher-js";
import {debugf} from "@helpers/string";

export default {
    data: () => ({
        pusherInstance: null,
    }),
    methods: {
        initializePusher() {
            if (!this.pusherInstance) {
                debugf([`#pusher -- Initializing instance`]);
                this.pusherInstance = new Pusher(window.env.PUSHER_APP_KEY, {
                    cluster: window.env.PUSHER_APP_CLUSTER,
                    authEndpoint: window.env.SS_API_BROADCASTING_ENDPOINT,
                });
            }

            return this.pusherInstance;
        },
        subscribePusherChannel(channelName, events = {}) {
            if (!this.pusherInstance) {
                this.initializePusher();
            }

            if (channelName && this.pusherInstance) {
                const channel = this.pusherInstance.subscribe(channelName);

                typeof events === 'object'
                && Object.keys(events).forEach(name => {
                    debugf([`#pusher -- Subscribe to channel ${channelName}`, `event ${name}`]);
                    channel.bind(name, data => {
                        debugf([`#pusher -- Event ${name} triggered`], data);
                        events[name](data);
                    });
                });
            }
        },
        unsubscribePusherChannel(channelName) {
            if (channelName && this.pusherInstance) {
                this.pusherInstance.unsubscribe(channelName);
            }
        },
    },
};